// src/layouts/Pages/PageHeader/CardHeaderColumns/items/email.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MailOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const emailItem = record => {
  const email = record?.email?.value || record?.email;

  const handleClick = () => {
    appService.handleCopyToClipboard(email);

    appService.notification({
      flag: 'success',
      icon: <MailOutlined />,
      title: 'email_copied',
      description: translateX('send_email_question', { email }),
      noTranslateDescription: true,
      duration: 0,
      actions: [
        { text: 'no', type: 'default' },
        { text: 'yes', type: 'primary', onClick: () => window.open(`mailto:${email}`, '_self') },
      ],
    });
  };

  return {
    key: 'email',
    icon: <MailOutlined />,
    label: email,
    tooltipText: translateX('email'),
    tooltipPlacement: 'right',
    onClick: email ? handleClick : null,
  };
};

export default emailItem;
